import { request } from '../axios';
import type { AddressContactDto } from '../generated/model';

type RequestOptions = Parameters<typeof request>[1];

export type GetAddressContactsDropdownParams = {
  search?: string;
};

export type AddressContactDropdownDto = Omit<
  AddressContactDto,
  'addressId' | 'email' | 'firstName' | 'function' | 'id' | 'lastName' | 'phone' | 'salutation'
> & {
  id?: string | null;
  addressId?: string | null;
  salutation?: 'MR' | 'MRS' | null;
  firstName?: string | null;
  lastName?: string | null;
  function?: string | null;
  phone?: string | null;
  email?: string | null;
  isPinned: boolean;
};

export const getAddressContactsDropdown = (
  params?: GetAddressContactsDropdownParams,
  options?: RequestOptions,
  signal?: AbortSignal,
) => {
  return request<AddressContactDropdownDto[]>(
    {
      url: '/api/addresses/contacts/dropdown',
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};
